import React from 'react';

const CTASection = ({ title, description, buttonText, buttonLink }) => {
  return (
    <section className="py-16 bg-blue-950 text-white">
      <div className="container mx-auto px-4 text-center">
        <h2 className="text-3xl font-bold mb-6">{title}</h2>
        <p className="text-xl mb-8 max-w-3xl mx-auto">{description}</p>
        <a 
          href={buttonLink} 
          className="bg-orange-500 hover:bg-orange-600 text-white px-8 py-4 rounded-md font-medium text-lg inline-block"
        >
          {buttonText}
        </a>
      </div>
    </section>
  );
};

export default CTASection;
